import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of as observableOf, Observable } from 'rxjs';
import { ErrorResponse, SuccessResponse } from '../../response';

@Injectable({ providedIn: 'root' })
export class FilecenterService {

    constructor(private http: HttpClient) { }

    public isFileCenterActive = true;

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${FilecenterService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'fileexports';

    public getExports(filter: any): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + '/filters', filter).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public getInvitationListExports(eventId: string, page): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + `/${eventId}` + '/invitations', page).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public getAttendeeListExports(eventId: string, page): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + `/${eventId}` + '/attendees', page).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public getContactListExports(page): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + '/contacts', page).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public getMailStatisticsExports(page): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + '/mailstatistics', page).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public getInteractionsExports(page): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + '/interactions', page).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public getUtmStatisticsExports(page): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + '/utmstatistics', page).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public getRegistrationDetailsExports(eventId: string, page): Observable<SuccessResponse<any> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<any>>(FilecenterService.URL + `/${eventId}` + '/registrationdetails', page).pipe(
                catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }

    public deleteExport(fileId: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(FilecenterService.URL + `/${fileId}`).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error?.messages ?? error.error))));
    }
}
